import { actionFactory } from 'redux/factories';
import { types } from './types';

export const getExchangeRates = actionFactory(types.GET_EXCHANGE_RATES);
export const editExchangeRates = actionFactory(types.UPDATE_EXCHANGE_RATES);
export const createExchangeRates = actionFactory(types.CREATE_EXCHANGE_RATES);
export const getExchangeRateForDate = actionFactory(
  types.GET_EXCHANGE_RATE_FOR_DATE,
);
